module.exports = __webpack_public_path__ + "static/media/gifts.7cf6bc9d.jpg";